/**
 * Базовый axios instance с interceptors — общий для всех API-клиентов.
 */
import axios from 'axios'
import { API_CONFIG } from './config'
import { setupAuthInterceptor } from './interceptors/auth.interceptor'
import { setupLocaleInterceptor } from './interceptors/locale.interceptor'
import { setupTimezoneInterceptor } from './interceptors/timezone.interceptor'

// Создаем базовый axios instance
export const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Подключаем interceptors
setupAuthInterceptor(apiClient)
setupLocaleInterceptor(apiClient)
setupTimezoneInterceptor(apiClient)
